(() => {
  const root = document.querySelector('[data-mm-hero]');
  if (!root) return;

  const slides = [...root.querySelectorAll('[data-mm-hero-slide]')];
  if (slides.length < 2) return;

  let index = slides.findIndex((slide) => slide.classList.contains('is-active'));
  if (index < 0) index = 0;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let timer = 0;

  const show = (next) => {
    slides[index].classList.remove('is-active');
    slides[index].setAttribute('aria-hidden', 'true');
    index = (next + slides.length) % slides.length;
    slides[index].classList.add('is-active');
    slides[index].removeAttribute('aria-hidden');
  };

  const stop = () => {
    window.clearInterval(timer);
    timer = 0;
  };

  const start = () => {
    if (reduce) return;
    stop();
    timer = window.setInterval(() => show(index + 1), 6500);
  };

  root.querySelector('[data-mm-hero-prev]')?.addEventListener('click', () => {
    show(index - 1);
    start();
  });
  root.querySelector('[data-mm-hero-next]')?.addEventListener('click', () => {
    show(index + 1);
    start();
  });

  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    root.addEventListener('pointerenter', stop);
    root.addEventListener('pointerleave', start);
  }

  let touchX = 0;
  let touchY = 0;
  root.addEventListener('pointerdown', (event) => {
    if (event.target.closest('a, button')) return;
    touchX = event.clientX;
    touchY = event.clientY;
  });
  root.addEventListener('pointerup', (event) => {
    if (event.target.closest('a, button')) return;
    const dx = event.clientX - touchX;
    const dy = event.clientY - touchY;
    if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy)) return;
    show(dx > 0 ? index - 1 : index + 1);
    start();
  });

  window.addEventListener('keydown', (event) => {
    if (!root.matches(':hover') && document.activeElement !== root && !root.contains(document.activeElement)) {
      return;
    }
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      show(index - 1);
      start();
    } else if (event.key === 'ArrowRight') {
      event.preventDefault();
      show(index + 1);
      start();
    }
  });

  start();
})();
